module.exports = __webpack_public_path__ + "img/france-pregnancy-childbirth-and-the-puerperium-female.6025f402.png";